import { Reveal, HeroBand, usePageMeta } from "../components/kit";
import { UI, DISCLAIMER_I18N } from "../data/content";

export default function Legal({ kind }) {
  const T = UI.pages.legal;
  const [title, standfirst] = T.titles[kind];
  usePageMeta(`${title} | KairosHK`, standfirst);
  return (
    <div data-testid={`legal-page-${kind}`}>
      <HeroBand image="facade" eyebrow={T.eyebrow} title={title} standfirst={standfirst} compact />
      <section className="k-section">
        <div className="k-container">
          <div className="max-w-3xl space-y-12">
          {T.sections[kind].map(([t, body], i) => (
            <Reveal key={t} delay={i * 0.03}>
              <h2 className="k-h3 mb-3">{t}</h2>
              <p className="text-ink-muted leading-relaxed text-[0.95rem]">{body}</p>
            </Reveal>
          ))}
          {kind === "legal" && (
            <Reveal>
              <p className="text-xs text-ink-muted leading-relaxed border-t border-line pt-6">{DISCLAIMER_I18N}</p>
            </Reveal>
          )}
          </div>
        </div>
      </section>
    </div>
  );
}
